export enum PermissionType {
  ViewUsers = 'viewUsers',
  ViewUserRoles = 'viewUserRoles',
  EditUserRoles = 'editUserRoles',
  ViewAuditEvents = 'viewAuditEvents',
  CreateBusinessArea = 'createBusinessArea',
  DeleteBusinessArea = 'deleteBusinessArea',
  EditBusinessArea = 'editBusinessArea',
  ViewBusinessArea = 'viewBusinessArea',
  ViewBusinessAreaContent = 'viewBusinessAreaContent',
  EditBusinessAreaContent = 'editBusinessAreaContent',
}
